export default __webpack_public_path__ + "static/media/2.blur.8cd5e32f.jpeg";